var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seletores"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4004 22.4C6.87739 22.4 2.40039 17.923 2.40039 12.4C2.40039 6.87703 6.87739 2.40002 12.4004 2.40002C17.9234 2.40002 22.4004 6.87703 22.4004 12.4C22.4004 17.923 17.9234 22.4 12.4004 22.4ZM11.4034 16.4L18.4734 9.32903L17.0594 7.91502L11.4034 13.572L8.57439 10.743L7.16039 12.157L11.4034 16.4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxControl);
export default __webpack_public_path__ + "static/media/checkbox_control.b47ab136b012d4441c255b7a63ad2803.svg";
export { ForwardRef as ReactComponent };